import {getScript, isMobile} from "../modules/general";

const MAP_DEFAULT_ZOOM = 15;
const MAP_MAX_ZOOM = 20;

document.addEventListener('DOMContentLoaded', () => {
    const wrapperMap = document.querySelector('#map');

    if (!wrapperMap) return;

    const AddMapBalloon = (map, clusterer, data) => {
      let placemarks = [];
      data.forEach((elem) => {
        let lang = window.navigator.language.slice(0, 2);
        let priceData = (elem.price) ? `<span class="balloon__cost">${elem.from} <span class="currency-price ${elem.currency} ${lang}"><b class="price-num">${elem.price.toLocaleString()}</b> <span class="currency">${elem.currency}</span></span>${elem.cost}</span>` : ``;
        let bookingBtn = (elem.urlHotelBooking) ? `<a href="${elem.urlHotelBooking}" target="_blank" rel="noopener" class="balloon__button button button--default">${elem.bookingBtn}</a> ` : '';
        let placemark = new ymaps.Placemark(elem.geometry.coordinates, {
            balloonContentBody: '<div class="balloon">'
              + `<a class="balloon__header" target="_blank" rel="noopener" href="${elem.url}">${elem.name}</a>`
              + `<p class="balloon__address icon icon-location_24_fill">${elem.address}</p>`
              + `<div class="balloon__price">`
              + priceData
              + bookingBtn
              + `</div>`
              + '</div>'
          },
          {
            iconLayout: ymaps.templateLayoutFactory.createClass('<div class="map__marker icon icon-location_24_fill"></div>'),
            iconShape: {
              type: 'Rectangle',
              coordinates: [
                [-25, -25],
                [50, 50]
              ]
            },
            iconOffset: [-25, -40]
          });
        placemarks.push(placemark);
      });
      clusterer.add(placemarks);
      map.geoObjects.add(clusterer);
      map.setBounds(clusterer.getBounds(), {
        checkZoomRange: true,
        zoomMargin: 10
      }).then(function () {
        if (map.getZoom() > MAP_MAX_ZOOM) {
          map.setZoom(MAP_DEFAULT_ZOOM);
        }
      }, function (e) {
      });
    };

    const initializeMap = () => {
      // маркер отеля
      if (typeof hotelMarker == "object") {
        const placemark = hotelMarker.location,
          behaviors = ['drag', 'dblClickZoom', 'multiTouch', 'zoom'],
          map = new ymaps.Map('map', {
            behaviors: behaviors,
            center: placemark ? placemark : [55.76, 37.64],
            controls: [],
            zoom: MAP_DEFAULT_ZOOM,
          });

        map.container.fitToViewport();

        map.controls.add('zoomControl', {
          size: "small",
          position: {
            top: 45,
            right: 15
          }
        });

        if (isMobile.any()) {
          map.behaviors.disable('drag');
        }

        if (hotelMarker.mapGeoObjectsSource) {
          const customItemContentLayout = ymaps.templateLayoutFactory.createClass(
            '<div class="balloon_body">{{ properties.balloonContentBody|raw }}</div>'
          );

          const clusterer = new ymaps.Clusterer({
            clusterDisableClickZoom: true,
            clusterOpenBalloonOnClick: true,
            clusterBalloonContentLayout: 'cluster#balloonCarousel',
            clusterBalloonItemContentLayout: customItemContentLayout,
            clusterBalloonContentLayoutWidth: 300,
            clusterBalloonContentLayoutHeight: 180,
            clusterBalloonPagerSize: 5,
            clusterIconLayout: ymaps.templateLayoutFactory.createClass('<div class="map__marker map__marker--cluster icon icon-location_24_fill"><span class="map__marker-count">{{ properties.geoObjects.length }}</span></div>'),
            clusterIconShape: {
              type: 'Rectangle',
              coordinates: [
                [-25, -25],
                [50, 50]
              ]
            }
          });

          fetch(hotelMarker.mapGeoObjectsSource, {
            method: 'POST',
          })
            .then(response => response.json())
            .then(function (data) {
              AddMapBalloon(map, clusterer, data);
            });
        } else {
          const sizeValue = (window.innerWidth < 360) ? [26, 30] : ((window.innerWidth < 1326) ? [34, 40] : [42, 50]);
          const offsetValue = (window.innerWidth < 360) ? [-13, -30] : ((window.innerWidth < 1326) ? [-17, -40] : [-21, -50]);

          const markerDefault = {
            iconLayout: ymaps.templateLayoutFactory.createClass(
              '<div class="map__marker icon icon-location_24_fill"></div>'
            ),
            iconSize: sizeValue,
            iconOffset: offsetValue,
            iconShape: {
              type: 'Rectangle',
              coordinates: [[0, 0], sizeValue]
            }
          };

          map.geoObjects.add(new ymaps.Placemark(placemark, {
            hintContent: hotelMarker.title
          }, markerDefault));
        }
      }
    };

    const loadMap = () => {
      if (typeof hotelMarker == "object") {
        const parameters = (!hotelMarker.yaMapApiKey || /^\s*$/.test(hotelMarker.yaMapApiKey)) ? 'lang=' + hotelMarker.locale : 'apikey=' + hotelMarker.yaMapApiKey + '&lang=' + hotelMarker.locale;
        getScript('//api-maps.yandex.ru/2.1/?' + parameters)
          .then(() => {
            ymaps.ready(() => {
              initializeMap();
            });
          })
          .catch(() => {
            console.error('Could not load script')
          })
      }
    };

    const callback = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio > 0) {
          observer.unobserve(entry.target);
          loadMap();
        }
      });
    };

    if (!('IntersectionObserver' in window)) {
      loadMap();
    } else {
      const config = {
        rootMargin: '500px 0px',
        threshold: 0
      };

      const observer = new IntersectionObserver(callback, config);
      observer.observe(wrapperMap);
    }
  }
);
